import { render } from "./modalAffinerChoix.vue?vue&type=template&id=70d8a7e3"
import script from "./modalAffinerChoix.vue?vue&type=script&lang=js"
export * from "./modalAffinerChoix.vue?vue&type=script&lang=js"

import "./modalAffinerChoix.vue?vue&type=style&index=0&id=70d8a7e3&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__